// extracted by mini-css-extract-plugin
export default {"title":"Quote_title__dp0nk","edit":"Quote_edit__g23-i","total":"Quote_total__FE2Nk"};